import { render, staticRenderFns } from "./WeiShouFuWuFei.vue?vue&type=template&id=176402e4&scoped=true&"
import script from "./WeiShouFuWuFei.vue?vue&type=script&lang=js&"
export * from "./WeiShouFuWuFei.vue?vue&type=script&lang=js&"
import style0 from "./WeiShouFuWuFei.vue?vue&type=style&index=0&id=176402e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176402e4",
  null
  
)

export default component.exports